import { useDispatch, useSelector } from 'react-redux';

import closeSvg from 'assets/icons/close.svg';
import { Store } from 'components/common/types/Store.types';
import Button, { Color, Size } from 'lib/Button';
import Modal from 'lib/Modal';
import { useDuplicateDeal } from 'customHooks/useDuplicateDeal';
import { changeFormParams, changeOnlyProgrammaticDealData } from 'store/dealManagement/reducer';
import { getDealId } from 'store/dealManagement/selectors/getDealId';

export const DspNoLongerInUseDialog: React.FC = () => {
  const dispatch = useDispatch();
  const dsp = useSelector((state: Store) => state.dealManagement.programmatic.dsp);
  const isDspNoLongerInUseDialogVisible = useSelector(
    (state: Store) => state.dealManagement.isDspNoLongerInUseDialogVisible,
  );
  const dealId = useSelector(getDealId);
  const { handleDuplicateDeal } = useDuplicateDeal();

  return (
    <Modal
      dataTestId="dsp-no-longer-in-use-modal"
      isOpen={isDspNoLongerInUseDialogVisible}
      icon={closeSvg}
      title={`${dsp?.name ? `"${dsp.name}"` : ''} DSP is no longer in use`}
      actionButtons={
        <>
          <Button
            color={Color.SECONDARY}
            size={Size.LARGE}
            onClick={() => {
              dispatch(changeOnlyProgrammaticDealData({ dspIsLegacy: true }));
              dispatch(changeFormParams({ isDspNoLongerInUseDialogVisible: false }));
            }}
            label="Cancel"
          />
          <Button
            color={Color.PRIMARY}
            size={Size.LARGE}
            onClick={() => {
              dispatch(changeOnlyProgrammaticDealData({ dspIsLegacy: false }));
              dispatch(changeFormParams({ isDspNoLongerInUseDialogVisible: false }));
              handleDuplicateDeal(dealId);
            }}
            label="OK, duplicate campaign without DSP"
          />
        </>
      }
    >
      <div className="ml-8 body-base text-neutral-950-opacity-60">
        This campaign is linked to a migrated DSP and can no longer be edited. To proceed, please clone the campaign and
        select a different DSP{dsp?.name ? ` than "${dsp.name}"` : ''}.
      </div>
    </Modal>
  );
};
